import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'appfile-web',
  templateUrl: './appfile-web.component.html',
  styleUrls: ['./appfile-web.component.scss'],
})
export class AppfileWebComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
